(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cc-3for2-offer"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '.cc-3for2--mini[data-cc-offer-count]';
  const sync = () => {
    const source = document.querySelector(selector);
    if (!source && !document.querySelector('#t4s-mini_cart .t4s-mini_cart__emty')) return;
    const count = source ? Number(source.dataset.ccOfferCount) : 0;
    const free = source ? Number(source.dataset.ccOfferFree) : 0;
    const cycle = count % 3;
    const progress = count > 0 && cycle === 0 ? 3 : cycle;
    for (const offer of document.querySelectorAll('.cc-3for2--product')) {
      const counter = offer.querySelector('.cc-3for2__progress-head strong');
      const fill = offer.querySelector('.cc-3for2__bar span');
      const status = offer.querySelector('.cc-3for2__status');
      if (counter && counter.textContent !== progress + '/3') counter.textContent = progress + '/3';
      if (fill) fill.style.width = (progress / 3 * 100) + '%';
      if (status) {
        const sourceStatus = source ? source.querySelector('.cc-3for2__status') : null;
        const message = count === 0 ? 'Добави 3 продукта, за да активираш офертата.' : sourceStatus ? sourceStatus.textContent.trim()
          : cycle === 0 ? 'Офертата е активна! Имаш ' + free + (free === 1 ? ' безплатен продукт.' : ' безплатни продукта.')
          : 'Имаш ' + free + (free === 1 ? ' безплатен продукт. ' : ' безплатни продукта. ') + 'Добави още ' + (3 - cycle) + ((3 - cycle) === 1 ? ' продукт' : ' продукта') + ' за следващ безплатен.';
        if (status.textContent.trim() !== message) status.textContent = message;
      }
    }
  };
  const init = () => {
    let pending = false;
    const observer = new MutationObserver(records => {
      const changed = records.some(record => {
        if (record.target.nodeType === 1 && record.target.closest(selector)) return true;
        return Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches(selector + ', .t4s-mini_cart__emty') || node.querySelector(selector + ', .t4s-mini_cart__emty')));
      });
      if (!changed || pending) return;
      pending = true;
      requestAnimationFrame(() => { pending = false; sync(); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
    sync();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cc-kl42-checkout-upsell"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const source = document.getElementById('cc-kl42-checkout-template');
      if (!source || window.__ccKl42CheckoutPreview || String(window.Shopify?.theme?.id) !== '200827830649' || window.Shopify?.theme?.role === 'main') return;
      window.__ccKl42CheckoutPreview = true;
      const panel = source.content.firstElementChild.cloneNode(true);
      const button = panel.querySelector('.cc-kl42-add');
      const notice = panel.querySelector('.cc-kl42-notice');
      button.addEventListener('click', () => {
        const selected = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(selected));
        button.textContent = selected ? panel.dataset.added : panel.dataset.add;
        notice.textContent = selected ? panel.dataset.selected : panel.dataset.idle;
      });
      const mount = () => {
        const modal = document.getElementById('mw-modal');
        const client = modal?.querySelector('.mw-client-info');
        const items = modal?.querySelectorAll('input[name^="products["][name$="[variant_id]"]');
        if (!client || !items?.length) {
          if (panel.isConnected && !panel.hidden) panel.hidden = true;
          return;
        }
        const alreadyInCart = Array.from(items).some(input => input.value === panel.dataset.variantId);
        if (panel.hidden !== alreadyInCart) panel.hidden = alreadyInCart;
        if (panel.parentElement !== client) client.prepend(panel);
      };
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => { scheduled = false; mount(); });
      });
      observer.observe(document.body, { childList: true, subtree: true });
      mount();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

})();
